// @flow
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { Navigate } from 'react-router';
import { exchangeCodeForToken, exchangeCodeForTokenIdp, exchangeSamlArtifact } from '../../features/auth/authSlice';

const hasSessionStorage = () => typeof window !== 'undefined' && window.sessionStorage;

const readSsoContext = () => {
  if (!hasSessionStorage()) return null;
  const raw = window.sessionStorage.getItem('sso:context');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn('Unable to parse SSO context', error);
    return null;
  }
};

const readOauth2Context = () => {
  if (!hasSessionStorage()) return null;
  const raw = window.sessionStorage.getItem('oauth2:context');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn('Unable to parse OAuth2 context', error);
    return null;
  }
};

const clearSsoContext = () => {
  if (!hasSessionStorage()) return;
  window.sessionStorage.removeItem('sso:context');
};

const clearOauth2Context = () => {
  if (!hasSessionStorage()) return;
  window.sessionStorage.removeItem('oauth2:context');
};

export const OauthCallback = (props) => {
  const authenticating = useRef(false)
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(useLocation().search)
  const [code] = useState(queryParams.get('code'))
  const [localError, setLocalError] = useState('')

  useEffect(() => {
    if (!code || authenticating.current || authState.isLoggedIn) {
      return;
    }

    const context = readSsoContext();
    const usingSaml = context?.method === 'SAML';
    const usingOauth2 = context?.method === 'OIDC_SECRET';
    const oauth2Context = usingOauth2 ? readOauth2Context() : null;
    const thunk = usingSaml ? exchangeSamlArtifact : exchangeCodeForToken;

    authenticating.current = true;

    const exchange = async () => {
      try {
        if (usingOauth2) {
          const countryCode = oauth2Context?.country || context?.country;
          const redirectUri = oauth2Context?.redirectUri;
          if (!countryCode || !redirectUri) {
            throw new Error('Missing OAuth2 context for token exchange');
          }
          await dispatch(
            exchangeCodeForTokenIdp({
              code,
              countryCode,
              redirectUri
            })
          ).unwrap();
        } else {
          await dispatch(thunk(code)).unwrap();
        }
      } catch (error) {
        console.error('Failed to exchange authentication code', error);
        setLocalError('Unable to verify sign-in request. Please try again.');
      } finally {
        clearSsoContext();
        clearOauth2Context();
      }
    };

    exchange();
  }, [authState.isLoggedIn, code, dispatch]);

  if (authState.isLoggedIn)
    return <Navigate to="/" replace />

  if (authState.loading)
    return <h1>Checking code please wait</h1>

  if (authState.error || localError)
    return <h1>{localError || 'Something went wrong '}</h1>

  return (
    <div>
      should have got code
    </div>
  );
};
